import React from 'react';
import { Route } from 'react-router';
import MainLayout from 'app/components/layouts/MainLayout';
import BorrowingLayout from 'app/components/borrowing/shared/BorrowingLayout';
import AuthenticatedRoute from 'app/routes/AuthenticatedRoute';
import AccountRequiredRoute from 'app/routes/AccountRequiredRoute';
import InterlibraryLoansPageRoute from './InterlibraryLoansPageRoute';

const basePath = '/v2/interlibraryloans';

export default (
  <Route
    path={`${basePath}/:status?`}
    element={
      <AuthenticatedRoute>
        <AccountRequiredRoute>
          <MainLayout deprecated>
            <BorrowingLayout>
              <InterlibraryLoansPageRoute />
            </BorrowingLayout>
          </MainLayout>
        </AccountRequiredRoute>
      </AuthenticatedRoute>
    }
  />
);
